import { render, staticRenderFns } from "./IconBadge.vue?vue&type=template&id=69b52c30"
import script from "./IconBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IconBadge.vue?vue&type=style&index=0&id=69b52c30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports